module.exports = __webpack_public_path__ + "static/digital-dentistry-b530b0cac7b3cb63536eebfb895b3529.png";